import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Grouping,
  Lookup,
} from 'devextreme-react/data-grid';

import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

import { useControlContent } from '../../../hooks/controlContent';

import ControlList from '../ControlList';
import GridLoader from '../../../components/GridLoader';

import { Board, BoardContent, BoardHeader } from '../../../components/Board';

import api from '../../../services/api';

export default function ExchangeRate() {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [taxPeriodSource] = useState({
    store: new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const response = await api.get('scheduling/tax-periods');
        const taxPeriodsWithDisplayValue = [];
        response.data.map(taxPeriod => {
          taxPeriodsWithDisplayValue.push({
            ...taxPeriod,
            DisplayValue: `${taxPeriod.Period}Q - ${taxPeriod.Year}`,
          });
        });

        return taxPeriodsWithDisplayValue;
      },
    }),
    paginate: true,
  });
  const [currencySource] = useState({
    store: new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        const response = await api.get('master/currencies');
        const currencyWithDisplayName = response.data.map(currency => ({
          ...currency,
          DisplayName: `${currency.Name} - ${currency.Abbreviation}`,
        }));

        return currencyWithDisplayName;
      },
    }),
    paginate: true,
  });

  const { setControlContent, setPageTitle } = useControlContent();

  // Set control menu
  useEffect(() => {
    setPageTitle('Finance');
    setControlContent(<ControlList />);

    const exchangeRateStore = new CustomStore({
      key: 'ID',
      loadMode: 'raw',
      load: async () => {
        try {
          setLoading(true);
          const response = await api.get('scheduling/exchange-rates');

          setLoading(false);
          return response.data;
        } catch (err) {
          console.log('load exchange rates', err);
        }
      },
    });

    const exchangeRateDataSource = new DataSource({
      store: exchangeRateStore,
      paginate: true,
      reshapeOnPush: true,
    });

    setDataSource(exchangeRateDataSource);
  }, [setControlContent, setPageTitle]);

  return (
    <Board>
      <BoardHeader
        title="Exchange Rate"
        description="View exchange rates (editable only through import)"
      />

      <BoardContent style={{ padding: 0, margin: 0, position: 'relative' }}>
        {loading ? (
          <GridLoader>
            <CircularProgress color="primary" />
          </GridLoader>
        ) : null}

        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          remoteOperations={false}
          key="ID"
          height="100%"
        >
          <FilterRow visible={true} />
          <HeaderFilter visible={true} />
          <Scrolling mode="infinite" />
          <Grouping autoExpandAll={false} />

          <Column dataField="IDCurrencyFrom" caption="Currency From">
            <Lookup
              dataSource={currencySource}
              displayExpr="DisplayName"
              valueExpr="ID"
            />
          </Column>
          <Column dataField="IDCurrencyTo" caption="Currency To">
            <Lookup
              dataSource={currencySource}
              displayExpr="DisplayName"
              valueExpr="ID"
            />
          </Column>
          <Column dataField="ConversionRateValue" caption="Value" />
          <Column dataField="TaxPeriod.ID" caption="Tax Period">
            <Lookup
              dataSource={taxPeriodSource}
              displayExpr="DisplayValue"
              valueExpr="ID"
            />
          </Column>
        </DataGrid>
      </BoardContent>
    </Board>
  );
}
